module.exports = __webpack_public_path__ + "img/trans-cub.59571552.jpg";